import { ClockCounterClockwise, Star, Fire, FlowerLotus, Medal, NotePencil, Confetti } from "@phosphor-icons/react";
import { SectionShell } from "../../styleguide/Primitives";
import { Showcase } from "../../library/LibraryPrimitives";
import { TimelineRail } from "../diagrams";

const ITEMS = [
  { label: "Today", title: "3 lessons · 45 XP earned", desc: "Multiplication & spelling", icon: Star, tone: "orange" },
  { label: "Yesterday", title: "Finished Fractions intro", desc: "First steps into a new topic", icon: Confetti, tone: "blue" },
  { label: "This Week", title: "5-day streak kept alive", desc: "Multiplication grew to Strong", icon: Fire, tone: "orange" },
  { label: "This Month", title: "Reading reached Mastered", desc: "In full bloom 🌸", icon: FlowerLotus, tone: "teal" },
  { label: "Homework history", title: "8 tasks completed · avg 92%", desc: "All saved with feedback", icon: NotePencil, tone: "teal" },
  { label: "Milestone", title: "First topic ever Mastered", desc: "A proud, remembered moment", icon: Medal, tone: "yellow" },
];

export function TimelineSection() {
  return (
    <SectionShell
      id="timeline"
      eyebrow="Timeline & Learning Journey"
      eyebrowIcon={ClockCounterClockwise}
      title="Bloom remembers, and shows the growth"
      description="A child's journey is visualised over time — today, this week, this month and across milestones. Looking back isn't about scores; it's a warm reminder of how far they've grown."
    >
      <Showcase title="A remembered journey" tone="muted">
        <TimelineRail items={ITEMS} />
      </Showcase>

      <div className="mt-5 grid gap-4 sm:grid-cols-3">
        {[
          { t: "Effort is recorded", d: "Every lesson, task and streak becomes part of the story." },
          { t: "Milestones are kept", d: "First masteries and badges are celebrated and revisited." },
          { t: "Growth is visible", d: "Children literally see themselves blooming over months and years." },
        ].map(({ t, d }) => (
          <div key={t} className="rounded-3xl border border-border bg-card p-5 shadow-soft">
            <p className="font-display font-extrabold text-primary-strong">{t}</p>
            <p className="mt-1 text-sm font-medium leading-relaxed text-muted-foreground">{d}</p>
          </div>
        ))}
      </div>
    </SectionShell>
  );
}

export default TimelineSection;
